import React from "react";
import { Button, Input } from "reactstrap";
import Select from "react-select";

export const ACTIVITY_FILTER_OPTIONS = [
  { label: "Scene Operation", value: "sceneOperation" },
  { label: "Switch Operation", value: "switchOperation" },
  { label: "Remote Operation", value: "remoteOperation" },
  { label: "Online", value: "online" },
  { label: "Offline", value: "offline" },
];

export const DEVICE_FILTER_TYPE_OPTIONS = [
  { label: "Chips", value: "chips" },
  { label: "Blaster", value: "blaster" },
  { label: "Air Curtain", value: "airCurtain" },
  { label: "Air Driver", value: "IOTdevice" },
  { label: "All", value: "any" },
];

export const DEVICE_FILTER_STATE_OPTIONS = [
  { label: "Online", value: "online" },
  { label: "Offline", value: "offline" },
  { label: "any", value: "any" },
];

export const CITY_FILTER_LABEL = "City";

export const FILTER_CONFIG: any = {
  onBoarded: {
    label: "User Profile Overview",
    options: [
      { label: "Has No Device", value: "onBorderdNoDevice" },
      {
        label: "Have Devices But Room Not Assigned",
        value: "onBorderdNotAssignedRoom",
      },
      { label: "Has Assigned Room to Devices", value: "onBorderdAssignedRoom" },
      { label: "Has Updated Name", value: "dataUpdateName" },
      { label: "Has Updated Email", value: "dataUpdateEmail" },
      { label: "Has Updated Profile Photo", value: "dataUpdateProfilePhoto" },
      { label: "Has Shared Premise to Other User", value: "shared" },
      { label: "Has Not Shared Premise to Other User", value: "sharednot" },
      { label: "Has Devices and Not Shared", value: "share2DeviceNotShared" },
      { label: CITY_FILTER_LABEL, value: "cityFilter", type: "city" },
    ],
  },

  using: {
    label: "Application Usage Behaviour",
    options: [
      { label: "User is Online Now", value: "usingOnline" },
      {
        label: "User is Opening Application Continuously Since X Days",
        type: "number",
        prefix: "usingAppOpen",
      },
      {
        label: "User is Operating Application Continuously Since X Days",
        type: "number",
        prefix: "usingAppOperate",
      },
      {
        label: "User is Not Opening Application Continuously Since X Days",
        type: "number",
        prefix: "usingAppNotOpen",
      },
      {
        label: "User is Not Operating Application Continuously Since X Days",
        type: "number",
        prefix: "usingAppNotOperate",
      },
    ],
  },

  automation: {
    label: "Automation Using Behaviour",
    options: [
      { label: "Scene Not Completed", value: "automationSceneNotCompleted" },
      {
        label: "Has Created More Than Scenes",
        type: "number",
        prefix: "automationSceneCount",
      },
      {
        label: "Scene Run Count > X",
        type: "number",
        prefix: "automationSceneRunCount",
      },
      { label: "Automation Not Completed", value: "automationNotCompleted" },
      {
        label: "Automation Count > X",
        type: "number",
        prefix: "automationCount",
      },
      {
        label: "Automation Run Count > X",
        type: "number",
        prefix: "automationRunCount",
      },
    ],
  },

  activity: {
    label: "Activity Filter",
    options: [
      {
        label: "Activity Filter (type, minutes, min count)",
        value: "activityFilter",
        type: "activity",
      },
    ],
  },

  device: {
    label: "Device Filter",
    options: [
      {
        label: "Device Filter (type, count, state)",
        value: "deviceFilter",
        type: "device",
      },
    ],
  },
};

type SelectFiltersProps = {
  rules: any[];
  ruleErrors: any[];
  filterConfig: any;
  cityOptions: any[];
  getSelectValue: (options: any[], value: string) => any;
  getCitySelectedOption: (value: string) => any;
  fetchCityOptions: (val: string, force?: boolean) => void;
  updateCategory: (index: number, value: string) => void;
  updateOption: (index: number, value: string) => void;
  updateNumber: (index: number, value: string) => void;
  updateMinutes: (index: number, value: string) => void;
  updateMinCount: (index: number, value: string) => void;
  updateActivityType: (index: number, value: string) => void;
  updateDeviceType: (index: number, value: string) => void;
  updateDeviceCount: (index: number, value: string) => void;
  updateDeviceState: (index: number, value: string) => void;
  updateCityIds: (index: number, value: string) => void;
  removeRule: (index: number) => void;
  addRule: () => void;
};

// const baseSelectStyles: any = {
//   menu: (provided: any) => ({
//     ...provided,
//     backgroundColor: "white", // Set background color for the dropdown menu
//     border: "1px solid #ccc", // Optional: Add border for clarity
//     boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Optional: Add shadow
//   }),
// };
const baseSelectStyles = {
  menu: (provided: any) => ({
    ...provided,
    backgroundColor: "white",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    fontWeight: "normal",
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: "#6c757d",
    fontWeight: "normal",
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: "#333",
    fontWeight: "normal",
  }),
  control: (provided: any) => ({
    ...provided,
    minHeight: 32,
    height: 32,
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  indicatorsContainer: (provided: any) => ({
    ...provided,
    height: 32,
  }),
    option: (provided: any, state: any) => ({
    ...provided,
    fontSize: 12,
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 8,
    paddingRight: 8,
  }),
};

const SelectFilters = ({
  rules,
  ruleErrors,
  filterConfig,
  cityOptions,
  getSelectValue,
  getCitySelectedOption,
  fetchCityOptions,
  updateCategory,
  updateOption,
  updateNumber,
  updateMinutes,
  updateMinCount,
  updateActivityType,
  updateDeviceType,
  updateDeviceCount,
  updateDeviceState,
  updateCityIds,
  removeRule,
  addRule,
}: SelectFiltersProps) => {
  return (
    <div>
      {rules?.map((rule, index) => {
        const categoryObj = filterConfig[rule.category];

        return (
          <div
            key={index}
            className="d-flex align-items-start mb-3 flex-wrap"
            style={{ gap: "12px" }}
          >
            <div className="d-flex flex-column" style={{ minWidth: 220 }}>
              <Select
                placeholder="Select Category"
                value={getSelectValue(
                  Object.entries(filterConfig).map(
                    ([key, obj]: [any, any]) => ({
                      value: key,
                      label: obj.label,
                    })
                  ),
                  rule.category
                )}
                options={Object.entries(filterConfig).map(
                  ([key, obj]: [any, any]) => ({
                    value: key,
                    label: obj.label,
                  })
                )}
                onChange={(opt: any) => updateCategory(index, opt?.value || "")}
                isSearchable={false}
                styles={baseSelectStyles}
                menuPortalTarget={document.body}
              />
              {ruleErrors[index]?.category && (
                <div className="text-danger small mt-1">
                  {ruleErrors[index]?.category}
                </div>
              )}
            </div>

            {rule.category !== "activity" && rule.category !== "device" && (
              <div className="d-flex flex-column" style={{ width: 260 }}>
                <Select
                  placeholder="Select Condition"
                  value={getSelectValue(
                    (categoryObj?.options || []).map((opt: any) => ({
                      value: opt.value || opt.prefix,
                      label: opt.label,
                    })),
                    rule.option
                  )}
                  isDisabled={!rule.category}
                  options={(categoryObj?.options || []).map((opt: any) => ({
                    value: opt.value || opt.prefix,
                    label: opt.label,
                  }))}
                  onChange={(opt: any) => updateOption(index, opt?.value || "")}
                  isSearchable={false}
                  styles={baseSelectStyles}
                  menuPortalTarget={document.body}
                />
                {ruleErrors[index]?.option && (
                  <div className="text-danger small mt-1">
                    {ruleErrors[index]?.option}
                  </div>
                )}
              </div>
            )}

            <div className="d-flex flex-column" style={{ gap: 8 }}>
              {categoryObj?.options.find(
                (opt: any) =>
                  opt.prefix === rule.option || opt.value === rule.option
              )?.type === "number" && (
                <>
                  <Input
                    type="number"
                    min={1}
                    max={999}
                    value={rule.number}
                    placeholder="Enter value"
                    onChange={(e) => updateNumber(index, e.target.value)}
                    bsSize="sm"
                    style={{ minHeight: "32px", width: 100 }}
                  />
                  {ruleErrors[index]?.number && (
                    <div className="text-danger small mt-1">
                      {ruleErrors[index]?.number}
                    </div>
                  )}
                </>
              )}

              {categoryObj?.options.find(
                (opt: any) => opt.value === rule.option
              )?.type === "activity" && (
                <div
                  className="d-flex flex-wrap align-items-start"
                  style={{ gap: "10px" }}
                >
                  <div style={{ minWidth: 180 }}>
                    <Select
                      placeholder="Select type"
                      value={getSelectValue(
                        ACTIVITY_FILTER_OPTIONS,
                        rule.activityType
                      )}
                      options={ACTIVITY_FILTER_OPTIONS}
                      onChange={(opt: any) =>
                        updateActivityType(index, opt?.value || "")
                      }
                      isSearchable={false}
                      styles={baseSelectStyles}
                      menuPortalTarget={document.body}
                    />
                    {ruleErrors[index]?.activityType && (
                      <div className="text-danger small mt-1">
                        {ruleErrors[index]?.activityType}
                      </div>
                    )}
                  </div>

                  <div style={{ minWidth: 100 }}>
                    <Input
                      type="number"
                      min={1}
                      max={999}
                      value={rule.minutes}
                      placeholder="Enter minutes"
                      onChange={(e) => updateMinutes(index, e.target.value)}
                      bsSize="sm"
                      style={{ minHeight: "32px" }}
                    />
                    {ruleErrors[index]?.minutes && (
                      <div className="text-danger small mt-1">
                        {ruleErrors[index]?.minutes}
                      </div>
                    )}
                  </div>

                  <div style={{ minWidth: 100 }}>
                    <Input
                      type="number"
                      min={1}
                      max={999}
                      value={rule.minCount}
                      placeholder="Enter min count"
                      onChange={(e) => updateMinCount(index, e.target.value)}
                      bsSize="sm"
                      style={{ minHeight: "32px" }}
                    />
                    {ruleErrors[index]?.minCount && (
                      <div className="text-danger small mt-1">
                        {ruleErrors[index]?.minCount}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {categoryObj?.options.find(
                (opt: any) => opt.value === rule.option
              )?.type === "device" && (
                <div
                  className="d-flex flex-wrap align-items-start"
                  style={{ gap: "10px" }}
                >
                  <div style={{ minWidth: 180 }}>
                    <Select
                      placeholder="Select device type"
                      value={getSelectValue(
                        DEVICE_FILTER_TYPE_OPTIONS,
                        rule.deviceType
                      )}
                      options={DEVICE_FILTER_TYPE_OPTIONS}
                      onChange={(opt: any) =>
                        updateDeviceType(index, opt?.value || "")
                      }
                      isSearchable={false}
                      styles={baseSelectStyles}
                      menuPortalTarget={document.body}
                    />
                    {ruleErrors[index]?.deviceType && (
                      <div className="text-danger small mt-1">
                        {ruleErrors[index]?.deviceType}
                      </div>
                    )}
                  </div>

                  <div style={{ minWidth: 120 }}>
                    <Input
                      type="text"
                      value={rule.deviceCount}
                      placeholder='e.g. "10" or "5-10"'
                      onChange={(e) => updateDeviceCount(index, e.target.value)}
                      bsSize="sm"
                      style={{ minHeight: "32px" }}
                    />
                    {ruleErrors[index]?.deviceCount && (
                      <div className="text-danger small mt-1">
                        {ruleErrors[index]?.deviceCount}
                      </div>
                    )}
                  </div>

                  <div style={{ minWidth: 140 }}>
                    <Select
                      placeholder="Select state"
                      value={getSelectValue(
                        DEVICE_FILTER_STATE_OPTIONS,
                        rule.deviceState
                      )}
                      options={DEVICE_FILTER_STATE_OPTIONS}
                      onChange={(opt: any) =>
                        updateDeviceState(index, opt?.value || "")
                      }
                      isSearchable={false}
                      styles={baseSelectStyles}
                      menuPortalTarget={document.body}
                    />
                    {ruleErrors[index]?.deviceState && (
                      <div className="text-danger small mt-1">
                        {ruleErrors[index]?.deviceState}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {categoryObj?.options.find(
                (opt: any) => opt.value === rule.option
              )?.type === "city" && (
                <div
                  className="d-flex flex-wrap align-items-start"
                  style={{ gap: "10px" }}
                >
                  <div style={{ minWidth: 260, flex: 1 }}>
                    <Select
                      placeholder="Search and select city"
                      value={getCitySelectedOption(rule.cityIds)}
                      options={cityOptions}
                      onInputChange={(val) => {
                        fetchCityOptions(val);
                        return val;
                      }}
                      onFocus={() => fetchCityOptions("", true)}
                      onChange={(selected: any) =>
                        updateCityIds(index, selected?.value || "")
                      }
                      isClearable
                      styles={baseSelectStyles}
                      menuPortalTarget={document.body}
                    />
                    {ruleErrors[index]?.cityIds && (
                      <div className="text-danger small mt-1">
                        {ruleErrors[index]?.cityIds}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {rules.length > 1 && (
              <Button
                color="link"
                size="sm"
                className="d-flex align-items-center justify-content-center"
                style={{ padding: 0, minWidth: 32, minHeight: 32 }}
                onClick={() => removeRule(index)}
              >
                <box-icon name="trash" size="18px" color="#6d6d6eff"></box-icon>
              </Button>
            )}
          </div>
        );
      })}

      <Button color="outline-primary" size="sm" onClick={addRule}>
        + AND
      </Button>
    </div>
  );
};

export default SelectFilters;
